import * as MutationTypes from "../mutation_types"
import { State, AuthHeaders, PublicAvailability } from "../store_types"
import { complaintPublicAvailabilitiesCreateAPI, complaintPublicAvailabilityDestroyAPI, callComplaintPublicAvailabilityAPI } from "../../api/complaint_public_availabilities"
import { HTTP_STATUS_NO_CONTENT } from "../../api/index"
import { AxiosResponseHeaders } from "axios"

const getDefaultState  = () => {
  return {
    complaintPublicAvailability: null
  }
}

const complaintPublicAvailabilities = {
  state: () => getDefaultState(),

  getters: {
    complaintPublicAvailability (state : State) {
      return state.complaintPublicAvailability
    }
  },

  actions: {
    createComplaintPublicAvailability({ dispatch, commit, getters}: { dispatch: (actionName: string, result?: boolean) => void, commit: (mutationType:string, resultData: AxiosResponseHeaders | PublicAvailability) => void, getters: { [key: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        complaintPublicAvailabilitiesCreateAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedComplaintsDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, status: number) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            if(status == HTTP_STATUS_NO_CONTENT) {
              dispatch("fetchComplaintsPublished", true)
              dispatch("fetchComplaintPublicAvailability")
            }
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    deleteComplaintPublicAvailability({ dispatch, commit, getters}: { dispatch: (actionName: string, result: boolean) => void, commit: (mutationType:string, resultData: AxiosResponseHeaders | null) => void, getters: { [key: string]: AuthHeaders}}, complaintPublicAvailabilityId: number){
      return new Promise<void>((resolve, reject) => {
        complaintPublicAvailabilityDestroyAPI(
          getters.authHeaders as AuthHeaders,
          complaintPublicAvailabilityId,
          // Success
          (headers: AxiosResponseHeaders, status: number) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            if(status == HTTP_STATUS_NO_CONTENT) {
              dispatch("fetchComplaintsPublished", false)
              commit(MutationTypes.ASSIGN_COMPLAINT_PUBLICATION_AVAILABILITY, null)
            }
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    fetchComplaintPublicAvailability({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders | PublicAvailability) => void, getters: { [key: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callComplaintPublicAvailabilityAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedComplaintsDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, publicAvailability: PublicAvailability) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_COMPLAINT_PUBLICATION_AVAILABILITY, publicAvailability)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    resetComplaintPublicAvailabilitiesState ({ commit }: { commit: (mutationType:string) => void }) {
      commit(MutationTypes.RESET_COMPLAINT_PUBLIC_AVAILABILITIES_STATE)
    },
  },

  mutations: {
    [MutationTypes.ASSIGN_COMPLAINT_PUBLICATION_AVAILABILITY](state: State, publicAvailability: PublicAvailability) {
      state.complaintPublicAvailability = publicAvailability
    },
    [MutationTypes.RESET_COMPLAINT_PUBLIC_AVAILABILITIES_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
  }
}

export default complaintPublicAvailabilities
